// extracted by mini-css-extract-plugin
export default {"popup":"EmailChangePopup__popup--1ur","header":"EmailChangePopup__header--1zO","inner":"EmailChangePopup__inner--32O"};